import { FC } from "react";
import { FieldInputProps } from "react-final-form";

import { IPickerListItem, Picker } from "@livechat/design-system-react-components";

import { TicketStatus, TicketStatusFormattedValues } from "interfaces/entities/ticket";
import { IRuleActionStatus } from "store/entities/rules/interfaces";

import { shortPickerStyles } from "../../styles";
import { changeActionValues } from "../utils";

interface IProps {
  input: FieldInputProps<IRuleActionStatus>;
}

export const Status: FC<IProps> = ({ input }) => {
  const foundOption = options.find(opt => opt.key === input.value?.status?.toString());
  const status = foundOption ? [foundOption] : [];

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const onSelect = (selected: IPickerListItem[] | null) => {
    if (!selected) {
      return;
    }
    const itemKey = selected[0].key as TicketStatus;
    changeActionValues(input, { status: itemKey });
  };
  return (
    <Picker
      options={options}
      onSelect={onSelect}
      selected={status}
      hideClearButton
      placeholder="Select status..."
      data-testid="status-picker"
      css={shortPickerStyles}
    />
  );
};

const options = [
  {
    key: TicketStatus.Open,
    name: TicketStatusFormattedValues[TicketStatus.Open],
  },
  {
    key: TicketStatus.Pending,
    name: TicketStatusFormattedValues[TicketStatus.Pending],
  },
  {
    key: TicketStatus.OnHold,
    name: TicketStatusFormattedValues[TicketStatus.OnHold],
  },
  {
    key: TicketStatus.Solved,
    name: TicketStatusFormattedValues[TicketStatus.Solved],
  },
  {
    key: TicketStatus.Closed,
    name: TicketStatusFormattedValues[TicketStatus.Closed],
  },
];
